exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.archived-contracts[data-v-5fae1516] {\n  background: #EDEDED;\n}\n.archived-contracts__table[data-v-5fae1516] {\n  margin-top: 1.5rem;\n  border-radius: 2px;\n  -webkit-box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.08);\n          box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.08);\n}\n.counterparty-cell[data-v-5fae1516] {\n  width: 30%;\n}\n.contract-number-cell[data-v-5fae1516] {\n  width: 20%;\n}\n.archived-contracts__view-details-btn[data-v-5fae1516] {\n  float: right;\n}\n.archived-contracts__no-contracts[data-v-5fae1516] {\n  margin: 1rem auto;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fae1516","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/contracts/index/archive/Contracts.ArchivedList.vue
// module id = RtzG
// module chunks = 1